import * as styles from "./PageHeader.css";

import { clsx } from "clsx";
import type { JSX } from "react";

import { Icon } from "@frontend/components/atoms/Icon";

import type { PageHeaderBreadcrumbProps } from "./PageHeader.types";

export function PageHeaderBreadcrumb({
  icon,
  children,
  className,
}: PageHeaderBreadcrumbProps): JSX.Element {
  return (
    <div
      data-slot="page-header-breadcrumb"
      className={clsx(styles.breadcrumb, className)}
    >
      {icon && <Icon name={icon} size="sm" />}

      {children}
    </div>
  );
}
